type FullNameRecord = { firstName: string, lastName: string };

export const fullName = (a: FullNameRecord) => a.firstName + " " + a.lastName;
